import React, { useState, useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import {
  FileUploadSection,
  DocumentDetailsSection,
  DocumentLinkingSection,
  FileAccessSection
} from '../components/DocumentComponents';

const DocumentUploadForm = ({ 
  files = [], 
  onFilesChange, 
  selectedCategory = null, 
  onCategoryChange, // Note: keeping selectedCategory prop name for API compatibility
  folderId = null,
  categories = [],
  dynamicFields = {},
  onDynamicFieldsChange,
  // File access fields
  isPrivate = false,
  onIsPrivateChange,
  selectedBranches = [],
  onBranchesChange,
  selectedDepartments = [],
  onDepartmentsChange,
  selectedSubDepartments = [],
  onSubDepartmentsChange,
  branches = [],
  departments = [],
  subDepartments = [],
  filteredDepartments = [],
  filteredSubDepartments = [],
  // User selection
  availableUsers = [],
  selectedUsers = [],
  onUsersChange,
  // Duplicate check
  duplicateFiles = [],
  checkingDuplicates = false,
  // New document fields
  documentTitle = '',
  onDocumentTitleChange,
  documentTitleError = '',
  documentRegisteredTo = '',
  onDocumentRegisteredToChange,
  documentRegisteredToError = '',
  documentReferenceNumber = '',
  onDocumentReferenceNumberChange,
  documentReferenceNumberError = '',
  documentIssueDate = '',
  onDocumentIssueDateChange,
  documentExpiryDate = '',
  onDocumentExpiryDateChange,
  remindMeBefore = '',
  onRemindMeBeforeChange,
  documentIssuingAuthority = '',
  onDocumentIssuingAuthorityChange,
  documentIssuingAuthorityError = '',
  otherComments = '',
  onOtherCommentsChange,
  otherCommentsError = '',
  // Edit mode - hide file upload section
  hideFileUpload = false,
  // Document linking fields
  linkToStaff = false,
  onLinkToStaffChange,
  staffId = null,
  onStaffIdChange,
  staffList = [],
  linkToVehicle = false,
  onLinkToVehicleChange,
  vehicleId = null,
  onVehicleIdChange,
  vehicleList = []
}) => {
  const previousFilesLengthRef = useRef(0);

  // Auto-populate document title from first file name (only when files are first added)
  useEffect(() => {
    // Only auto-populate when files go from 0 to >0 and title is empty
    const filesJustAdded = previousFilesLengthRef.current === 0 && files.length > 0;
    
    if (filesJustAdded && (!documentTitle || documentTitle.trim() === '') && onDocumentTitleChange) {
      const firstFile = files[0];
      const fileNameWithoutExtension = firstFile.name.replace(/\.[^/.]+$/, '');
      onDocumentTitleChange(fileNameWithoutExtension);
    }
    
    previousFilesLengthRef.current = files.length;
  }, [files, documentTitle, onDocumentTitleChange]);


  return (
    <Form>
      {/* File Upload Section with Preview */}
      <FileUploadSection
        files={files}
        onFilesChange={onFilesChange}
        checkingDuplicates={checkingDuplicates}
        hideFileUpload={hideFileUpload}
      />

      {/* Document Details Section */}
      <DocumentDetailsSection
        selectedCategory={selectedCategory}
        onCategoryChange={onCategoryChange}
        categories={categories}
        documentTitle={documentTitle}
        onDocumentTitleChange={onDocumentTitleChange}
        documentTitleError={documentTitleError}
        documentRegisteredTo={documentRegisteredTo}
        onDocumentRegisteredToChange={onDocumentRegisteredToChange}
        documentRegisteredToError={documentRegisteredToError}
        documentReferenceNumber={documentReferenceNumber}
        onDocumentReferenceNumberChange={onDocumentReferenceNumberChange}
        documentReferenceNumberError={documentReferenceNumberError}
        documentIssueDate={documentIssueDate}
        onDocumentIssueDateChange={onDocumentIssueDateChange}
        documentExpiryDate={documentExpiryDate}
        onDocumentExpiryDateChange={onDocumentExpiryDateChange}
        remindMeBefore={remindMeBefore}
        onRemindMeBeforeChange={onRemindMeBeforeChange}
        documentIssuingAuthority={documentIssuingAuthority}
        onDocumentIssuingAuthorityChange={onDocumentIssuingAuthorityChange}
        documentIssuingAuthorityError={documentIssuingAuthorityError}
        otherComments={otherComments}
        onOtherCommentsChange={onOtherCommentsChange}
        otherCommentsError={otherCommentsError}
      />

      {/* Document Linking Section */}
      <DocumentLinkingSection
        linkToStaff={linkToStaff}
        onLinkToStaffChange={onLinkToStaffChange}
        staffId={staffId}
        onStaffIdChange={onStaffIdChange}
        staffList={staffList}
        linkToVehicle={linkToVehicle}
        onLinkToVehicleChange={onLinkToVehicleChange}
        vehicleId={vehicleId}
        onVehicleIdChange={onVehicleIdChange}
        vehicleList={vehicleList}
      />

      {/* File Access Section */}
      <FileAccessSection
        isPrivate={isPrivate}
        onIsPrivateChange={onIsPrivateChange}
        selectedBranches={selectedBranches}
        onBranchesChange={onBranchesChange}
        selectedDepartments={selectedDepartments}
        onDepartmentsChange={onDepartmentsChange}
        selectedSubDepartments={selectedSubDepartments}
        onSubDepartmentsChange={onSubDepartmentsChange}
        branches={branches}
        departments={departments}
        subDepartments={subDepartments}
        filteredDepartments={filteredDepartments}
        filteredSubDepartments={filteredSubDepartments}
        availableUsers={availableUsers}
        selectedUsers={selectedUsers}
        onUsersChange={onUsersChange}
      />
    </Form>
  );
};

export default DocumentUploadForm;

